import PropTypes from "prop-types";
import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { brand } from "../theme/theme";
import { useTheme as useCustomTheme } from "../theme/useTheme";
import { formatDecimal } from "../utils/numberFormat";

const DEVICE_LABELS = { mobile: "Móvil", desktop: "Ordenador", tablet: "Tablet" };

/** Share of sessions per device (GA4 `devices`): one stacked bar plus its legend. */
export function DeviceShare({ devices }) {
  const theme = useTheme();
  const { neutrals } = useCustomTheme();
  const tones = [theme.palette.primary.main, brand.orange, neutrals.gray[300]];

  return (
    <Stack spacing={1.25}>
      <Stack direction="row" spacing="2px" sx={{ height: 10, borderRadius: 5, overflow: "hidden" }}>
        {devices.map((device, index) => (
          <Box key={device.name} sx={{ width: `${device.share_percent}%`, backgroundColor: tones[index % tones.length] }} />
        ))}
      </Stack>
      <Stack direction="row" spacing={1.75} flexWrap="wrap" useFlexGap>
        {devices.map((device, index) => (
          <Stack key={device.name} direction="row" spacing={0.75} alignItems="center" sx={{ fontSize: "0.75rem" }}>
            <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: tones[index % tones.length] }} />
            <span>{DEVICE_LABELS[device.name] || device.name}</span>
            <Box component="b" sx={{ fontWeight: 600 }}>
              {formatDecimal(device.share_percent, 0)} %
            </Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

DeviceShare.propTypes = { devices: PropTypes.arrayOf(PropTypes.object).isRequired };
